import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-tender-accept-bid',
    templateUrl: './tender-accept-bid.component.html',
    styleUrls: ['./tender-accept-bid.component.scss'],
    imports: [I18nModule]
})
export class TenderAcceptBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  productInfo: any;
  @Input() productsInfo:any;
  @Input() price:number;
  biddingTerms = '';
  requestParams: any;
  reqTenderEntries:any = [];
  @Output() refreshList = new EventEmitter<string>();
  acceptTxt:string = null;

  constructor(private customProductService: CustomProductsService,private router:Router,public ActiveModal: NgbActiveModal,private customProductsService: CustomProductsService,private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.productInfo=this.productsInfo.quoteEntries;
    console.log(this.productInfo);
    this.customProductsService.getAccepttxt().subscribe((txt)=>{
      this.acceptTxt = txt;      
    })
  }
  close(): any {
    this.ActiveModal.close();
  }
  acceptbid(){
    {
      this.requestParams={
        "quoteAction": "ACCEPTED",
        "tender": {
          "quoteCode": this.productsInfo.quoteCode,
        }
      }
    }
 
    console.log(this.requestParams);
    this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
      console.log(resp);
      if(resp.status === 'ACCEPTED'){
        this.toastrService.show('You have accepted the offer');
        this.ActiveModal.close();
        this.refreshList.emit(resp)
        this.router.navigate([`/quotes/myquotes`]);
      }else{
        this.toastrService.show(resp.status);
      }
      
    },
    err=>{
      console.log(err);
      this.ActiveModal.close();
      this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
    })
  }

}
